import React, { Component } from "react";
import PublicationPage from "../Images/publication.jpg";

class Journal extends Component {
  render() {
    return (
      <div className="container">
        <img className="img-fluid" src={PublicationPage} alt="Founders" />
        <h1 className="page-header text-center head">
          Journal, Article Writing and Publication
        </h1>
      </div>
    );
  }
}

export default Journal;
